export default __webpack_public_path__ + "static/ins-logo-c25b6708ffc3a7d85e4dc8b5234edadc.png";